import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=766b912a&scoped=true&"
import script from "./UserOrders.vue?vue&type=script&lang=ts&"
export * from "./UserOrders.vue?vue&type=script&lang=ts&"
import style0 from "./UserOrders.vue?vue&type=style&index=0&id=766b912a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b912a",
  null
  
)

export default component.exports